import React, { useState } from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Avatar,
  Box,
  Button,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { UserAuth } from "../contexts/AuthContext";
import PasswordResetModal from "./PasswordResetModal";
import ProfileEditModal from "./ProfileEditModal";

const UserAccountMenu = () => {
  const { user, logout } = UserAuth();
  const [isPwdModalOpen, setPwdModalOpen] = useState(false);
  const [isProfileModalOpen, setProfileModalOpen] = useState(false);

  if (!user) return null;

  const fullName = `${user.firstName || ""} ${user.lastName || ""}`.trim();
  const isGoogleUser = user.signInMethod === "google";

  const changePasswordItem = (
    <MenuItem
      onClick={() => setPwdModalOpen(true)}
      isDisabled={isGoogleUser}
    >
      Change password
    </MenuItem>
  );

  return (
    <>
      <Menu placement="bottom-end">
        <Tooltip label={`${fullName} (${user.email})`} hasArrow>
          <MenuButton
            as={Button}
            variant="unstyled"
            minW={0}
            height="auto"
            padding={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            aria-label="Open user account menu"
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar name={fullName} size="sm" />
              <Text
                fontSize="sm"
                fontWeight="medium"
                display={{ base: "none", md: "inline" }}
                noOfLines={1}
              >
                {fullName}
              </Text>
            </Box>
          </MenuButton>
        </Tooltip>
        <MenuList>
          <Box px={3} py={2}>
            <Text fontWeight="bold" fontSize="sm" noOfLines={1}>
              {fullName}
            </Text>
            <Text fontSize="xs" color="gray.500" noOfLines={1}>
              {user.email}
            </Text>
          </Box>
          <MenuDivider />
          <MenuItem onClick={() => setProfileModalOpen(true)}>Profile</MenuItem>
          {isGoogleUser ? (
            <Tooltip label="Managed by your Google account" hasArrow placement="left">
              <Box>{changePasswordItem}</Box>
            </Tooltip>
          ) : (
            changePasswordItem
          )}
          <MenuDivider />
          <MenuItem onClick={logout} color="red.500">
            Logout
          </MenuItem>
        </MenuList>
      </Menu>
      <PasswordResetModal
        isOpen={isPwdModalOpen}
        onClose={() => setPwdModalOpen(false)}
        initialEmail={user.email}
      />
      <ProfileEditModal
        isOpen={isProfileModalOpen}
        onClose={() => setProfileModalOpen(false)}
      />
    </>
  );
};

export default UserAccountMenu;
